/**
 * Player-facing copy for a daily attempt that didn't complete - used by
 * `DailyChallengeScene`, `DailyResultScene`, and `DailyLeaderboardScene`.
 * Presentation only: the wire/DB value stays `"failed"` everywhere else
 * (see `DailyRunContext.ts`/`validation.ts`'s `status: "completed" |
 * "failed"`, and the ranking order in `daily-result.ts`) - nothing here
 * changes what's stored, submitted, or ranked.
 */
export const DAILY_INCOMPLETE_LABEL = "INCOMPLETE";
